import { Component, ElementRef, ViewChild } from '@angular/core';
import { WizBasePopUp, WizLabel, WizEventManager } from '@wizeoo/akm-component-lib';
import { WidgetConfigurationObj } from '@wizeoo/akm-message-lib';

import { ALK_EVENT_TYPE } from '../../../model/enums';
import { FreedataValueVO } from  '../../../vo/core/freedatavalue.vo';
import { FreeDataVO } from '../../../vo/core/freedata.vo';
import { FastSelectData } from '../../../manager/widgets/widget.engine';
import { AlkEvent } from '../../../framework/events/alk.event';
import { Model } from '../../../model/model';
import { IFreedataWidget } from '../../../manager/widgets/i-widget';


import { FreedataFormWidget } from '../freedataform/freedata-form.widget';

// FormulaEngineInstance tel que stocké en cache local
export interface calendarEditPopVO {
  widget: IFreedataWidget,
  freedata: FreeDataVO,
  freedataValue?: FreedataValueVO,
  startDate?: number,
  context: WidgetConfigurationObj,
  callback?: Function
}


@Component({
  // popUp d'ajout d'une entrée de calendrier
  selector: 'freedata-calendar-add-pop',
  templateUrl: './freedata-calendar-add.pop.html',
})
export class FreedataCalendarAddPop extends WizBasePopUp {
  // zone d'ajout des champs de saisie
  // @ViewChild('containerDrops', { read: ViewContainerRef, static: true }) containerDrops: ViewContainerRef;

  @ViewChild('formWid', { read: FreedataFormWidget }) formWid: FreedataFormWidget;
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)

  constructor(public elementRef: ElementRef) {
    super();
  }

  public code: string = 'calForm';
  public saveDisabled: boolean = true; // par défaut, on sauvegarde pas. Tous les champs doivent être OK
  public declare datas: calendarEditPopVO;

  public get model(): Model {
    return this.datas.widget.model;
  }

  public context: WidgetConfigurationObj; // la configuration

  public show(): void {
    this.drawContent();

    WizEventManager.addListener(this, this.formWid, ALK_EVENT_TYPE.FORM_SAVED, this.hide);
    WizEventManager.addListener(this, this.formWid, ALK_EVENT_TYPE.FORM_CANCELED, this.hide);

  }

  /** construction des champs de saisie */
  public drawContent() {
    this.formWid.context = this.datas.context;
    this.formWid.currentFDV = this.datas.freedataValue;
    this.formWid.setDatasource(this.model.currentVision, null, null);
    // this.formWid.outerSelect(this.datas.freedataValue); // injection de la PL
    this.formWid.showSelect = false;
    this.formWid.showAdd = false;
    this.formWid.showDelete = false;
    let fsd: FastSelectData = {fei: null, kind: this.datas.widget.widgetGlobalKind, data: this.datas.freedataValue};
    let e: AlkEvent = new AlkEvent(ALK_EVENT_TYPE.PIVOT_DOUBLE, fsd);
    this.formWid.injectFreedataValue(e); // injection de la WidgetLine
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.hide();
  }

  public onHide(): void {
    WizEventManager.removeListener(this, this.formWid, ALK_EVENT_TYPE.FORM_SAVED);
    WizEventManager.removeListener(this, this.formWid, ALK_EVENT_TYPE.FORM_CANCELED);
  }
}
